<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            codeGroupCd="IBM_TASK_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ibmTaskTypeCd"
            label="업무"
            v-model="searchParam.ibmTaskTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            stepperGrpCd="IBM_STEP_CD"
            :rejectItems="['IS00000001']"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ibmStepCd"
            label="진행단계"
            v-model="searchParam.ibmStepCd"
          ></c-select>
        </div>
        <!-- <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="요청부서"
            name="improveRequestDeptCd"
            v-model="searchParam.improveRequestDeptCd"
          />
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept 
            :isFirstValue="false"
            type="search" 
            label="주관부서" 
            name="hostDept" 
            v-model="searchParam.hostDept" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="(기간)조치완료 요청일"
            name="actionCompleteRequestDates"
            v-model="searchParam.actionCompleteRequestDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-1 col-lg-1 col-xl-1">
          <c-checkbox
            :isFlag="true"
            falseLabel="All"
            label="지연된 업무 확인"
            name="overFlag"
            v-model="searchParam.overFlag"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="개선 목록"
      tableId="impr01"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            :disabled="!grid.data || grid.data.length === 0"
            label="개선결과보고서"
            icon="print"
            @btnClicked="imprResultPrint"
          />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'actionCompleteRequestDate'">
          <span
            :style="
              props.row.approvalStatusCd === 'ASC9999999'
                ? 'text-decoration: line-through'
                : ''
            "
          >
            {{ props.row.actionCompleteRequestDate }}
            <q-badge
              v-if="
                props.row.completeDateOver > 0 &&
                props.row.ibmStepCd !== 'IS00000001' &&
                props.row.approvalStatusCd !== 'ASC9999999'
              "
              color="negative"
              label="지연"
              class="blinking"
            />
          </span>
          <span v-if="props.row.approvalStatusCd === 'ASC9999999'">
            👉 {{ props.row.targetDate }}
          </span>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "impr",
  data() {
    return {
      searchParam: {
        plantCd: null,
        actionCompleteRequestDates: [],
        ibmTaskTypeCd: null,
        ibmStepCd: null,
        improveRequestDeptCd: null,
        actionVendorCd: "",
        actionFlag: "V",
        overFlag: "N",
        hostDept: '',
        ibmStepVendorFlag: "Y",
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
          {
            name: 'ibmClassName',
            field: 'ibmClassName',
            label: '구분',
            align: 'center',
            style: 'width:60px',
            sortable: true,
          },
          {
            name: "ibmTaskTypeName",
            field: "ibmTaskTypeName",
            label: "업무",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
          {
            name: "ibmTitle",
            field: "ibmTitle",
            label: "제목",
            align: "left",
            style: "width:250px",
            type: "link",
            sortable: true,
          },
          {
            name: "ibmStepName",
            field: "ibmStepName",
            label: "진행단계",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "improveRequestDeptName",
            field: "improveRequestDeptName",
            label: "요청부서",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "sopImprovementId",
            field: "sopImprovementId",
            label: "개선번호",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "improveRequestContents",
            field: "improveRequestContents",
            label: "요청정보",
            align: "left",
            style: "width:200px",
            sortable: true,
          },
          {
            name: "actionCompleteRequestDate",
            field: "actionCompleteRequestDate",
            label: "조치완료 요청일",
            align: "center",
            style: "width:170px",
            type: "custom",
            sortable: true,
          },
          {
            name: "approvalStatusName",
            field: "approvalStatusName",
            label: "지연 결재",
            align: "center",
            sortable: true,
            style: "width:90px",
          },
          {
            name: 'hostDeptName',
            field: 'hostDeptName',
            label: '주관부서',
            align: 'center',
            sortable: true,
            style: 'width:90px',
          },
          {
            name: "actionCompleteDate",
            field: "actionCompleteDate",
            label: "조치완료일",
            align: "center",
            style: "width:90px",
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: "",
      printUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  computed: {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.ibm.improve.list.url;
      this.printUrl = selectConfig.sop.ibm.improve.print.url;
      // code setting
      // list setting
      this.searchParam.actionVendorCd = this.$store.getters.user.userId;
      this.searchParam.improveRequestDeptCd = "";
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = "개선 상세"; // 개선 상세
      this.popupOptions.param = {
        sopImprovementId: row ? row.sopImprovementId : "",
      };
      this.popupOptions.target = () => import(`${"./imprDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    imprResultPrint() {
      let thisVue = this;
      this.$http.url = this.printUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request(
        (_result) => {
          let fileOrgNm = "개선 결과 보고서_" + this.$comm.getToday() + ".xlsx";
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        },
        () => {},
      );
    },
  },
};
</script>
